import React from 'react';

// Importing images for hotel avatars (adjust the paths as necessary)
import novotel from './../assets/avatars/novotel.jpg';
import totto from './../assets/avatars/totto.jpg';
import sage from './../assets/avatars/sage.jpg';
import quest from './../assets/avatars/quest.jpg';
import mantra from './../assets/avatars/mantra.jpg';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const hotels = [
  {
    title: "Novotel Wollongong Northbeach (One of the conference's location)",
    avatar: novotel,
    name: "2-14 Cliff Rd, North Wollongong, NSW 2520",
    position: "Phone: +(02) 4224 3111; Email:  hotel@novotelnorthbeach.com.au",
    price: "One Queen bed: $AUD 275 per night; Two beds: $AUD 319 per night",
    containing: "Coffee/tea maker; Fridge; Buffet breakfast (6:30 - 10:30 AM): AUD 42 for adults and AUD 19 for children",
    url: "http://novotelnorthbeach.com.au",
    transport: "Transport to UOW [Free bus: Walk 200 meters and take the 55A/55C free bus.]"
  },
  {
    title: "Quest Wollongong",
    avatar: quest,
    name: "60-62 Harbour Street, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 4221 1500",
    price: "One Queen bed: $AUD 249 per night; Three beds(1 king bed and 2 single beds): $AUD 329 per night",
    containing: "Coffee/tea maker; Full sized fridge; Cookware/dishes/utensils; Dining area; Dishwasher",
    url: "https://www.questapartments.com.au/properties/nsw/wollongong/quest-wollongong",
    transport: "Transport to UOW [Free bus: Walk 400 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 400 meters and take the 55A free bus.]"
  },
  {
    title: "Mantra Wollongong",
    avatar: mantra,
    name: "6-10 Gladstone Ave, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 4222 4000; Email: info@wollongonghotelapartments.com.au",
    price: "One Queen bed: $AUD 299 per night; Two beds: $AUD 383 per night",
    containing: "Coffee/tea maker; Full sized fridge; Cookware/dishes/utensils; Dining area; Dishwasher",
    url: "https://mhwollongong.com.au/",
    transport: "Transport to UOW [Free bus: Walk 150 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 150 meters and take the 55A free bus.]"
  },
  {
    title: "Sage Hotel Wollongong",
    avatar: sage,
    name: "59-61 Kembla Street, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 4201 2111; Email: reservations.wollongong@sage-hotels.com",
    price: "One Queen bed: $AUD 279 per night; Two beds: $AUD 279 per night",
    containing: "continental breakfast (6:30 - 9:30 AM): AUD 20-40 for adults and AUD 12.5-20 for children",
    url: "https://www.nexthotels.com/sage/wollongong/",
    transport: "Transport to UOW [Free bus: Walk 550 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 550 meters and take the 55A free bus.]"
  },
  {
    title: "Hotel TOTTO Wollongong",
    avatar: totto,
    name: "60 Market St, Wollongong, NSW 2520",
    position: "Phone: +(61) 2 9069 5528; Email: reservations_hoteltotto@evt.com",
    price: "One Queen bed: $AUD 214 per night; Two beds: $AUD 241 per night",
    containing: "Coffee/tea maker; Minibar; Cooked-to-order breakfast (7:00 - 10:00 AM): AUD 25 for adults and AUD 15 for children",
    url: "https://www.hoteltotto.com/",
    transport: "Transport to UOW [Free bus: Walk 350 meters and take the 55C free bus.]; Transport to Novotel [Free bus: Walk 350 meters and take the 55A free bus.]"
  },

];

function HotelsList() {
   return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ fontSize: '2rem', textAlign: 'center', marginBottom: '10px' }}>
      <strong>Conference Venue</strong>
      </h1>
      <p >
        The University of Wollongong is proud to host <strong>International Conference on Advanced Manufacturing and Materials for Sustainable Mining Equipment and Technologies 2025</strong> The City of 
        Wollongong is located just 80km south of Sydney on a spectacular stretch of the southern 
        New South Wales coast. Wollongong’s natural environment includes some of the most pristine 
        beaches in Australia and the escarpment to the west offers a great network of walking trails 
        and dazzling views of the coastline.
      </p>

      <h1 style={{ marginTop: '40px',fontSize: '2rem' }}><strong>Hotel Information</strong></h1>
      {hotels.map((hotel, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            gap: '20px',
            alignItems: 'flex-start',
            margin: '20px 0',
            padding: '20px',
            border: '1px solid #ccc',
            borderRadius: '10px',
            flexWrap: 'wrap',
            textOverflow: "ellipsis",

          }}
        >
          <a href={hotel.url} target="_blank" rel="noopener noreferrer">
            <img
              src={hotel.avatar}
              alt={hotel.title}
              style={{
                width: '120px',
                height: '120px',
                objectFit: 'cover',
                borderRadius: '8px',
                flexShrink: 0,
                cursor: 'pointer'
              }}
            />
          </a>
          <div>
            <h2>{hotel.title}</h2>
            <p><strong>Address:</strong> {hotel.name}</p>
            <p><strong>Contact:</strong> {hotel.position}</p>
            <p><strong>Price:</strong> {hotel.price}</p>
            <p><strong>Amenities:</strong> {hotel.containing}</p>
            <p><strong>Transport:</strong> {hotel.transport}</p>
            <a href={hotel.url} className='underline blue' target="_blank" rel="noopener noreferrer">Visit website<ArrowOutwardIcon /></a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default HotelsList;